import type { ReactElement } from 'react';
import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import type { BackofficeModule } from '../registry';
import { AssetRegisterPage } from './AssetRegisterPage';
import { AssetDetailPage, AssetsPage } from './AssetsPage';
import { CountDetailPage, CountsPage } from './CountsPage';
import { LocationsPage } from './LocationsPage';
import { MovementsPage } from './MovementsPage';
import { StockDetailPage } from './StockDetailPage';
import { StockPage } from './StockPage';

const gate = (permission: string, element: ReactElement) => <ModuleGate module="inventory" permission={permission}>{element}</ModuleGate>;

/**
 * Einstiegspunkt des Moduls Lager und Inventar im Backoffice (KON-166, Schlüssel `inventory`, siehe docs/lager.md): Bestände, Bewegungen, Lagerorte und Inventur unter
 * /lager, die Betriebsmittel unter /inventar.
 */
export const inventoryModule: BackofficeModule = {
  key: 'inventory',
  path: '/lager',
  nav: [
    { label: 'Lager', path: '/lager' },
    // Das Inventar (Anlagegüter mit Anschaffungswert und Abschreibung) gehört zu den Finanzen, direkt hinter den Kontenplan, gefolgt vom Anlagenspiegel
    { label: 'Inventar', path: '/inventar', group: 'finance', after: 'chart' },
    { label: 'Anlagenspiegel', path: '/inventar/anlagenspiegel', permission: 'inventory.values', group: 'finance', after: 'chart' },
  ],
  routes: (
    <>
      <Route path="lager" element={gate('inventory.read', <StockPage />)} />
      <Route path="lager/bestand/:productId" element={gate('inventory.read', <StockDetailPage />)} />
      <Route path="lager/bewegungen" element={gate('inventory.read', <MovementsPage />)} />
      <Route path="lager/orte" element={gate('inventory.read', <LocationsPage />)} />
      <Route path="lager/inventur" element={gate('inventory.read', <CountsPage />)} />
      <Route path="lager/inventur/:id" element={gate('inventory.read', <CountDetailPage />)} />
      <Route path="inventar" element={gate('inventory.read', <AssetsPage />)} />
      <Route path="inventar/anlagenspiegel" element={gate('inventory.values', <AssetRegisterPage />)} />
      <Route path="inventar/:id" element={gate('inventory.read', <AssetDetailPage />)} />
    </>
  ),
};
